import "css/shippingResponsive.css";
import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT, LIMIT_PAGE  } from "constants/variables";
import Box from '@mui/material/Box'; 
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';  
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import PropTypes from 'prop-types';
import TableSortingShippingTrailers from 'pages/shipping/editOrNewShipping/SortingTablesShippingTrailers'; 

const initialFiltersTrailers= {
  "idFrom":"",
  "idTo":"",
  "documentIdFrom":"",
  "documentIdTo":"",
  "tradenameFrom":"",
  "tradenameTo":"",
  "vehicleStoreFrom":"",
  "vehicleStoreTo":""
};
 
const initinitialStateTrailers = [{
  "id":"",
  "licenseplate":0,
  "store_id":0,
  "store_documnettype_id":0,
  "store_tradename":""
}];
  
const ShippingSearchTrailers = ({ showModalSearchTrailers, setShowModalSearchTrailers,setFormShipping,formShipping}) => {
  const {t,i18n} = useTranslation(['listDataShipping']);
  const state = useSelector((state) => state);
  const {token} = state.loginUser
  const [dataTrailer, setDataTrailer] = useState(initinitialStateTrailers);
  const [isLoadingErrorTrailer, setIsLoadingErrorTrailer] = useState(false);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [inputTextTrailer, setInputTextTrailer] = useState("");
  const [applyFiltersTrailer, setApplyFiltersTrailer]= useState(initialFiltersTrailers);
  const [filtersTrailer, setFiltersTrailer]= useState(initialFiltersTrailers);
  const [openEditFilterTrailer,setOpenEditFilterTrailer]= useState(false);
  const [errorsFiltersTrailer, setErrorsFiltersTrailer] = useState({});
  const [numTotRegFilter,setNumTotRegFilter]= useState(0);
  const [numTotRegTrailer,setNumTotRegTrailer]= useState(0);
  const [activeOffsetTrailer, setActiveOffsetTrailer]= useState(false);
  const [currencyOffsetTrailer, setCurrencyOffsetTrailer] = useState(0);
  const [rangeOffsetTrailer, setRangeOffsetTrailer] = useState([{}]); 
  const dispatch = useDispatch(); 
   
  const keyPress = useCallback(
    (e) => {
      if (e.key === 'Escape' && setShowModalSearchTrailers) {
        setDataTrailer(initinitialStateTrailers);
        setIsLoadingErrorTrailer(false);
        dispatch(setLoading(false))
        setInputTextTrailer("");
        setApplyFiltersTrailer(initialFiltersTrailers);
        setFiltersTrailer(initialFiltersTrailers);
        setOpenEditFilterTrailer(false);
        setErrorsFiltersTrailer({});
        setNumTotRegFilter(0);
        setNumTotRegTrailer(0);
        setActiveOffsetTrailer(false);
        setCurrencyOffsetTrailer(0);
        setRangeOffsetTrailer([{}]);
        setShowModalSearchTrailers(false);
      }
    },
    [ setDataTrailer,
      setIsLoadingErrorTrailer, 
      setInputTextTrailer,
      setApplyFiltersTrailer,
      setFiltersTrailer,
      setOpenEditFilterTrailer,
      setErrorsFiltersTrailer,
      setNumTotRegFilter,
      setNumTotRegTrailer,
      setActiveOffsetTrailer,
      setCurrencyOffsetTrailer,
      setRangeOffsetTrailer,
      dispatch,
      setShowModalSearchTrailers
    ]
  );

  const handleCloseDataEditTrailer = () => {
    setDataTrailer(initinitialStateTrailers);
    setIsLoadingErrorTrailer(false);
    dispatch(setLoading(false))
    setInputTextTrailer("");
    setApplyFiltersTrailer(initialFiltersTrailers);
    setFiltersTrailer(initialFiltersTrailers);
    setOpenEditFilterTrailer(false);
    setErrorsFiltersTrailer({});
    setNumTotRegFilter(0);
    setNumTotRegTrailer(0);
    setActiveOffsetTrailer(false);
    setCurrencyOffsetTrailer(0);
    setRangeOffsetTrailer([{}]); 
    setShowModalSearchTrailers(false)
	};

  const toggleDrawerSearchFormTrailers  = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      handleCloseDataEditTrailer();
    }
  };

  let inputHandlerTrailer = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputTextTrailer(lowerCase);
  };

  const openEditFiltersTrailer = () => {
    setFiltersTrailer(applyFiltersTrailer);
    setOpenEditFilterTrailer(!openEditFilterTrailer);
  };

  const toggleDrawerFilterEditTrailer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      handleCloseDataEditTrailer();
    }
  };

  const handleCancelFiltersTrailer = () => {
    setErrorsFiltersTrailer({});
    setFiltersTrailer(initialFiltersTrailers);
    setOpenEditFilterTrailer(!openEditFilterTrailer);
  };

  const handleChangeFilterEditTrailer = (e) => {
    const { name, value } = e.target;
    setFiltersTrailer(filtersTrailer => ({
      ...filtersTrailer,
      [name]: value
    }));
  };

  const handleBlurFilterEditTrailer = (e) => {
    setErrorsFiltersTrailer(validateFormFilterTrailer());
    handleChangeFilterEditTrailer(e);
  };

  const handleSubmitFilterEditTrailer = () => {
    setErrorsFiltersTrailer(validateFormFilterTrailer());
    if (Object.keys(errorsFiltersTrailer).length === 0) {
      setApplyFiltersTrailer(filtersTrailer);
      setFiltersTrailer(initialFiltersTrailers);
      setErrorsFiltersTrailer({});
      setOpenEditFilterTrailer(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  const handleDeleteFiltersTrailer = () => {
    setErrorsFiltersTrailer({});
    setFiltersTrailer(initialFiltersTrailers);
    setApplyFiltersTrailer(initialFiltersTrailers);
    setOpenEditFilterTrailer(!openEditFilterTrailer);
  };

  const validateFormFilterTrailer = () => {

    let errorsFiltersTrailer = {};
    let regexNumber = /^[0-9]+$/;
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (filtersTrailer.idFrom!=="" & !regexNumber.test(filtersTrailer.idFrom)) {
      errorsFiltersTrailer.idFrom = 'Text_TextNoNumber';
    }
    if (filtersTrailer.idTo!=="" & !regexNumber.test(filtersTrailer.idTo)) {
      errorsFiltersTrailer.idTo = 'Text_TextNoNumber';
    }
    if (filtersTrailer.idFrom!=="" & !errorsFiltersTrailer.idFrom!==undefined){
      if (filtersTrailer.idTo!=="" & !errorsFiltersTrailer.idTo!==undefined){
        if (parseInt(filtersTrailer.idTo)<parseInt(filtersTrailer.idFrom)){
          errorsFiltersTrailer.idTo = 'Text_TextGreater_Id';
        }
      }
    }
    if (regexInvalidCharacters.test(filtersTrailer.tradenameFrom)) {
      errorsFiltersTrailer.tradenameFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersTrailer.tradenameTo)) {
      errorsFiltersTrailer.tradenameTo = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersTrailer.vehicleStoreFrom)) {
      errorsFiltersTrailer.vehicleStoreFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersTrailer.vehicleStoreTo)) {
      errorsFiltersTrailer.vehicleStoreTo = 'Text_TextNoValid';
    } 
    if (filtersTrailer.vehicleStoreTo!=="" & filtersTrailer.vehicleStoreTo<filtersTrailer.vehicleStoreFrom){
      errorsFiltersTrailer.vehicleStoreTo = 'Text_TextGreater_trailers';
    }
    return errorsFiltersTrailer;
  }  

  const filteredDataTrailer = dataTrailer.filter((el) => {
    if (inputTextTrailer === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.licenseplate || '')+
        String(el.store_documentid || '')+
        String(el.store_tradename || '') ;
      let result = dataTranslate.toLowerCase().includes(inputTextTrailer.toLowerCase());
      return result;  
    }
  })
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);
  
   
  useEffect(() => {
    let isMounted = true;

    const fetchnumTotRegTrailer = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, `shipping/getinformationtabletrailers`, token);
        if (getData.err) {
          setDataTrailer(initinitialStateTrailers);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegTrailer(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
 
    const fetchnumTotRegFilter = async () => {
      try {
        const getData = (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid!=="")
        ?await helpHttp().post2(ENDPOINT,`shipping/getcountfiltertrailersstore`,token,formShipping.rel_trans_documentid,applyFiltersTrailer)
        :await await helpHttp().post(ENDPOINT,`shipping/getcountfiltertrailers`,token,applyFiltersTrailer);
        if (getData.err || getData.message === "Load failed") {
          setDataTrailer(initinitialStateTrailers);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setNumTotRegFilter(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    const fetchDataTrailer = async () => {
      dispatch(setLoading(true));
      try {
        const getData = (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid!=="")
        ?await helpHttp().get4(ENDPOINT,`shipping/gettrailersstore`,token,formShipping.rel_trans_documentid,currencyOffsetTrailer,LIMIT_PAGE,applyFiltersTrailer)
        :await helpHttp().get3(ENDPOINT,`shipping/gettrailers`,token,currencyOffsetTrailer,LIMIT_PAGE,applyFiltersTrailer);
        if (getData.err || getData.message === "Load failed") {
          setDataTrailer(initinitialStateTrailers);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataTrailer(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    
    if (showModalSearchTrailers){
      fetchnumTotRegTrailer();
      fetchnumTotRegFilter();
      fetchDataTrailer();
    }
    return () => { isMounted = false };
  }, [t,i18n,token,dispatch,applyFiltersTrailer,currencyOffsetTrailer,showModalSearchTrailers,formShipping.rel_trans_documentid]);
  
  return(
    <>
      {showModalSearchTrailers && 
        <div>
          <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-lookup-panel" }}
            anchor='right'
            open={true}
            onClose={toggleDrawerSearchFormTrailers(false)}
            onOpen={toggleDrawerSearchFormTrailers(true)}>
            <Container maxWidth={false}>
              <Box sx={{ bgcolor: '#ffffff', width: '100%', maxWidth: '100%'}}>
                 <div className="formdi-pending-header2"> 
                  <h1 className="formdi-pending-title">
                    {isLoadingErrorTrailer?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={"primary"}/>:<i className="fas fa-address-card text-warning"></i>} {t('Text_TICKETS_Trailers_Search')}
                  </h1>
                  <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={handleCloseDataEditTrailer} >{t('Button_Back')}</button><> </>
                  </div> 
                </div>  
                <br/>
                <div className="formdi-pending-search"> 
                  <TextField
                    autoComplete="off"
                    id="outlined-basic"
                    variant="outlined"
                    value={inputTextTrailer}
                    inputProps={{ style: {fontSize: '18px'} }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}  
                    placeholder={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Trailer_Search'):t('Text_Vehicle_Store_Search')} 
                    onChange={inputHandlerTrailer}
                    fullWidth
                    label={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Trailer_Search'):t('Text_Vehicle_Store_Search')} >
                  </TextField>
                </div>
                <br/>
                <div id="myNewDIV" className="formdi-pending-filters">
                  <h1 className="formdi-pending-filter-title">{t('Text_Filter')}</h1> 
                    <div className="formdi-pending-filters-row">
                      <button type="button" className={`formdi-pending-chip ${applyFiltersTrailer.vehicleStoreFrom!=="" || applyFiltersTrailer.vehicleStoreTo!=="" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersTrailer} >
                        <span className={`formdi-pending-dot ${applyFiltersTrailer.vehicleStoreFrom!=="" || applyFiltersTrailer.vehicleStoreTo!==""? "formdi-pending-dot--on": ""}`}/>
                        {t("Text_SHIPPING_TRAILER")}
                      </button>
                      {(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")&&
                        <> 
                          <button type="button" className={`formdi-pending-chip ${(applyFiltersTrailer.documentIdFrom!=="" || applyFiltersTrailer.documentIdTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersTrailer} >
                            <span className={`formdi-pending-dot ${(applyFiltersTrailer.documentIdFrom!=="" || applyFiltersTrailer.documentIdTo!=="")? "formdi-pending-dot--on": ""}`}/>
                            {t("Text_documentid")}
                          </button>
                          <button type="button" className={`formdi-pending-chip ${(applyFiltersTrailer.tradenameFrom!=="" || applyFiltersTrailer.tradenameTo!=="")? "formdi-pending-chip--active": "" }`}  onClick={openEditFiltersTrailer} >
                            <span className={`formdi-pending-dot ${(applyFiltersTrailer.tradenameFrom!=="" || applyFiltersTrailer.tradenameTo!=="")? "formdi-pending-dot--on": ""}`}/>
                            {t("Text_tradename")}
                          </button>
                        </>
                      }  
                  </div>
                </div>  
                <br/>
                {!isLoadingData ?
                  <>
                    <div className="formdi-pending-card-flat">
                      <div className="formdi-pending-card-content"> 
                        <TableSortingShippingTrailers
                          dataTrailer={filteredDataTrailer}
                          numTotRegFilter={ numTotRegFilter}
                          titleTable={(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")?t('Text_Trailers_Table'):formShipping.rel_trans_tradename}
                          numTotRegTrailer={numTotRegTrailer}
                          activeOffsetTrailer={activeOffsetTrailer}
                          rangeOffsetTrailer={rangeOffsetTrailer}
                          currencyOffsetTrailer={currencyOffsetTrailer}
                          setCurrencyOffsetTrailer={setCurrencyOffsetTrailer} 
                          setFormShipping={setFormShipping}
                          handleCloseDataEditTrailer={handleCloseDataEditTrailer}
                        >
                        </TableSortingShippingTrailers>
                      </div>             
                    </div>
                    {openEditFilterTrailer &&
                      <div>
                      <SwipeableDrawer PaperProps={{ className: "shipping-search-panel shipping-lookup-panel" }}
            anchor='right'
                        open={true}
                        onClose={toggleDrawerFilterEditTrailer(false)}
                        onOpen={toggleDrawerFilterEditTrailer(true)}>
                        <Container maxWidth={false}>
                          <Box sx={{ bgcolor: '#ffffff',minHeight:'100vh', width: '100%' }}>
                            <br/>
                              <div id="myDIV">
                                <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                              </div>
                              <hr className="sidebar-divider d-none d-md-block"/>
                              <form autoComplete="off" className="shipping-search-filters newfilterformstore" onSubmit={handleCancelFiltersTrailer}>  
                                <div className="form-floating mb-3 px-4 primary">
                                  <div className="form-group">
                                    <TextField autoComplete="off"
                                      id="vehicleStoreFrom" 
                                      name="vehicleStoreFrom"
                                      value={filtersTrailer.vehicleStoreFrom}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersTrailer.vehicleStoreFrom!=null?t(errorsFiltersTrailer.vehicleStoreFrom):t('PlaceHolder_Filter_trailers_From')}
                                      placeholder={t('PlaceHolder_Filter_trailers_From')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditTrailer}
                                      onChange={handleChangeFilterEditTrailer}/>
                                    
                                    <TextField autoComplete="off"
                                    
                                      id="vehicleStoreTo" 
                                      name="vehicleStoreTo"
                                      value={filtersTrailer.vehicleStoreTo}
                                      inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 50 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      label={errorsFiltersTrailer.vehicleStoreTo!=null?t(errorsFiltersTrailer.vehicleStoreTo):t('PlaceHolder_Filter_trailers_to')}
                                      placeholder={t('PlaceHolder_Filter_trailers_to')}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditTrailer}
                                      onChange={handleChangeFilterEditTrailer}/>
                                  </div>
                                  {(formShipping.rel_trans_documentid===undefined || formShipping.rel_trans_documentid===null || formShipping.rel_trans_documentid==="")&&
                                    <>
                                      <div className="form-group">
                                        <TextField autoComplete="off"
                                          id="documentIdFrom" 
                                          name="documentIdFrom"
                                          value={filtersTrailer.documentIdFrom}
                                          inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersTrailer.documentIdFrom!=null?t(errorsFiltersTrailer.documentIdFrom):t('PlaceHolder_Filter_documentid_From')}
                                          placeholder={t('PlaceHolder_Filter_documentid_From')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditTrailer}
                                          onChange={handleChangeFilterEditTrailer}/>
                                        
                                        <TextField autoComplete="off"
                                        
                                          id="documentIdTo" 
                                          name="documentIdTo"
                                          value={filtersTrailer.documentIdTo}
                                          inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersTrailer.documentIdTo!=null?t(errorsFiltersTrailer.documentIdTo):t('PlaceHolder_Filter_documentid_to')}
                                          placeholder={t('PlaceHolder_Filter_documentid_to')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditTrailer}
                                          onChange={handleChangeFilterEditTrailer}/>
                                      </div>
                                      <div className="form-group">
                                        <TextField autoComplete="off"
                                          id="tradenameFrom" 
                                          name="tradenameFrom"
                                          value={filtersTrailer.tradenameFrom}
                                          inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersTrailer.tradenameFrom!=null?t(errorsFiltersTrailer.tradenameFrom):t('PlaceHolder_Filter_tradename_From')}
                                          placeholder={t('PlaceHolder_Filter_tradename_From')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditTrailer}
                                          onChange={handleChangeFilterEditTrailer}/>
                                          
                                        <TextField autoComplete="off"
                                          
                                          id="tradenameTo" 
                                          name="tradenameTo"
                                          value={filtersTrailer.tradenameTo}
                                          inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                          label={errorsFiltersTrailer.tradenameTo!=null?t(errorsFiltersTrailer.tradenameTo):t('PlaceHolder_Filter_tradename_to')}
                                          placeholder={t('PlaceHolder_Filter_tradename_to')}
                                          variant="outlined"
                                          onBlur={handleBlurFilterEditTrailer}
                                          onChange={handleChangeFilterEditTrailer}/>
                                      </div> 
                                    </>
                                  }                 
                                </div>
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <div className="formdi-pending-action-group">
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEditTrailer}>
                                    {t('Button_Apply')}
                                  </button> 
                                  <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFiltersTrailer}>
                                    {t('Button_Cancel_Filters')}
                                  </button>
                                </div>  
                            </form>
                          </Box>
                        </Container>
                      </SwipeableDrawer>
                    </div>
                  }  
                  {/* End Content Row */}
                  </>:
                    <LoadingNews/>   
                }
                                
              </Box>
            </Container>
          </SwipeableDrawer>
        </div>
      }  
    </>
  )
}

ShippingSearchTrailers.propTypes = {
  showModalSearchTrailers: PropTypes.bool.isRequired,
  setShowModalSearchTrailers: PropTypes.func.isRequired, 
  setFormShipping: PropTypes.func.isRequired
};

export default ShippingSearchTrailers;
